export default __webpack_public_path__ + "static/media/DZ.e749e3b0.svg";